/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeploymentMode,
    DeploymentModeFromJSON,
    DeploymentModeFromJSONTyped,
    DeploymentModeToJSON,
} from './DeploymentMode';

/**
 * 
 * @export
 * @interface ReportForDeviceResponseStbGroupHistoryElements
 */
export interface ReportForDeviceResponseStbGroupHistoryElements {
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    hardwareId: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    usageId: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    upgradeRuleId: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    upgradeRuleName: string;
    /**
     * 
     * @type {Date}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    dateHour: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    quota: number;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    deployedStbGroupCount: number;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    quotaFirmwareType: string;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    quotaDailyIncrement: number;
    /**
     * 
     * @type {DeploymentMode}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    deploymentMode: DeploymentMode;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    bpProfile: number;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    userEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReportForDeviceResponseStbGroupHistoryElements
     */
    isDisabled: boolean;
}

export function ReportForDeviceResponseStbGroupHistoryElementsFromJSON(json: any): ReportForDeviceResponseStbGroupHistoryElements {
    return ReportForDeviceResponseStbGroupHistoryElementsFromJSONTyped(json, false);
}

export function ReportForDeviceResponseStbGroupHistoryElementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceResponseStbGroupHistoryElements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'hardwareId': json['hardwareId'],
        'usageId': json['usageId'],
        'upgradeRuleId': json['upgradeRuleId'],
        'upgradeRuleName': json['upgradeRuleName'],
        'dateHour': (json['dateHour'] === null ? null : new Date(json['dateHour'])),
        'quota': json['quota'],
        'deployedStbGroupCount': json['deployedStbGroupCount'],
        'quotaFirmwareType': json['quotaFirmwareType'],
        'quotaDailyIncrement': json['quotaDailyIncrement'],
        'deploymentMode': DeploymentModeFromJSON(json['deploymentMode']),
        'bpProfile': json['bpProfile'],
        'userEmail': json['userEmail'],
        'isDisabled': json['isDisabled'],
    };
}

export function ReportForDeviceResponseStbGroupHistoryElementsToJSON(value?: ReportForDeviceResponseStbGroupHistoryElements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'hardwareId': value.hardwareId,
        'usageId': value.usageId,
        'upgradeRuleId': value.upgradeRuleId,
        'upgradeRuleName': value.upgradeRuleName,
        'dateHour': (value.dateHour === null ? null : value.dateHour.toISOString()),
        'quota': value.quota,
        'deployedStbGroupCount': value.deployedStbGroupCount,
        'quotaFirmwareType': value.quotaFirmwareType,
        'quotaDailyIncrement': value.quotaDailyIncrement,
        'deploymentMode': DeploymentModeToJSON(value.deploymentMode),
        'bpProfile': value.bpProfile,
        'userEmail': value.userEmail,
        'isDisabled': value.isDisabled,
    };
}

